import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AppRedirectService } from '../../services/api-redirect.service';
import { DeviceDetectorService } from '@core/services/device-detector.service';
import { environment } from 'src/environments/environment';
import { ConfigService } from '@core/services/config.service';

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.scss']
})
export class CookiesComponent implements OnInit {
  isConsentGiven: boolean = false;
  showcookiePopup: boolean = false;
  GuestuserCompId: string;
  detectedDeviceType: string = '';

  constructor(
    private readonly cookieService: CookieService,
    public readonly appRedirectService: AppRedirectService,
    public readonly deviceDetector: DeviceDetectorService,
    public readonly configService: ConfigService
  ) { }

  ngOnInit() {
    this.detectedDeviceType = this.deviceDetector.getDeviceType();
    if (this.detectedDeviceType === 'android' || this.detectedDeviceType === 'ios') {
      this.showcookiePopup = true;
    }
    this.checkConsent();
  }

navigate(): void {
  let storeUrl = '';

  if (this.detectedDeviceType === 'android') {
    storeUrl = this.configService.get('appUrls').android;
  } else {
    window.open(environment.mockObj.mockUrl, '_blank');
    return;
  }

  window.location.href = storeUrl;
}

checkConsent() {
    this.isConsentGiven = this.cookieService.check('cookieConsent');
  }

  acceptCookies() {
    this.cookieService.set('cookieConsent', 'accepted', 1, '/'); // Expires in 1 day
    this.isConsentGiven = true;
    this.showcookiePopup = false;
  }

  declineCookies() {
    this.cookieService.set('cookieConsent', 'declined', 1, '/'); // Expires in 1 day
    this.isConsentGiven = true;
    this.showcookiePopup = false;
  }

}
